export const changePassword = {
    "change_pwd_title": "تغيير كلمة المرور",
    "change_pwd_old_password": "كلمة المرور الحالية",
    "change_pwd_new_password": "كلمة المرور الجديدة",
    "change_pwd_confirm_password": "تأكيد كلمة المرور",
    "change_pwd_error": "خطأ في تغيير كلمة المرور"
}
